<template>
  <v-btn x-small @click="open">
    <v-icon small>mdi-magnify</v-icon>
  </v-btn>
</template>

<script>
import { mapGetters } from 'vuex';
import { v4 as uuidv4 } from 'uuid';

export default {
  props: {
    sstmId: {
      type: String,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    eventCode: {
      type: String,
      required: true,
    },
    storeName: [String],
    descendants: [Array],
    timestamp: [Number],
  },
  data() {
    return {
      uuid: uuidv4(),
      values: {},
    };
  },
  watch: {},
  computed: {
    ...mapGetters('common/system', ['getSystemById']),
    stackType() {
      return this.getSystemById(this.sstmId).stackType.toLowerCase();
    },
  },
  methods: {
    setValue() {
      Object.keys(this.$props).reduce((acc, key) => {
        acc[key] = this.$props[key];
        return acc;
      }, this.values);
    },
    open() {
      this.setValue();
      window[this.uuid] = this;
      const query = { uuid: this.uuid };
      window.open(`/views/detailview/${this.stackType}/data-viewer?${new URLSearchParams(query).toString()}`, '_blank', 'width=900, height=600');
    },
  },
};
</script>
